import React from "react";
import moment from "moment";

import { imageUrl } from "../../config/apiUrl";
import { CardDemoImg } from "../../constant/imagePath";
import classes from "./CollectionCard.module.css";

function CollectionCard({ data, onClick }) {
  let img = data ? imageUrl(data?.cards[0]?.photo) : CardDemoImg;
  let cardCount = data ? data?.cards?.length : 20;
  let publishDate = data
    ? moment(data?.createdAt).format("ll")
    : moment().format("ll");
  let tags = data ? data?.tags?.map((e) => e?.name) : ["Sports", "Athletes"];

  return (
    <div onClick={onClick} className={classes.card}>
      <div className={classes.imgBox}>
        <img src={img} />
      </div>
      <div className={classes.content}>
        <span className={classes.tag}>collection</span>
        <h4 className="t-t-c">{data?.name}</h4>
        <p>This include {cardCount} cards in this collection</p>
        <ul>
          <li>Published On: {publishDate}</li>
          <li>Tags: {tags?.join(", ")}</li>
        </ul>
      </div>
    </div>
  );
}

export default CollectionCard;
